export const apiKeysKeys = {
	all: ['apiKeys'],
	lists: () => [...apiKeysKeys.all, 'list'],
};

export const apiKeysMutationKeys = {
	create: ['apiKeys', 'create'],
	revoke: ['apiKeys', 'revoke'],
};
